import React, { useState, Fragment, useCallback, useEffect } from 'react';
import { translate } from '../../Services/translation';
import BuyButtonPack from '../BuyButtonPack/BuyButtonPack';
import { useDispatch } from 'react-redux';
import { reloadPayment } from '../../Actions/Checkout.action';
import { update } from '../../Actions/Cart.action';
import Icon from '../IconBase/Icon';
import { PercentageDiscount } from '../../Services/price';
//product card components
import ProductPrice from './ProductCardComponents/ProductPrice';
import ProductTotalPrice from './ProductCardComponents/ProductTotalPrice';
import ProductQuantity from './ProductCardComponents/ProductQuantity';

const CartProductCardMobile = ({
  orderRow,
  type,
  b2c,
  handleQuantityInput,
  removeOrderRow,
}) => {
  const [removingRow, setRemovingRow] = useState({});

  const ProductImage = useCallback(({ order }) => {
    return (
      <img
        className="checkout-cart__image"
        src={order.image}
        alt={order.name}
      />
    );
  }, []);

  const ProductName = useCallback(({ order }) => {
    return (
      <Fragment>
        <a href={order.url}>{order.name}</a>
        <span className="checkout-cart__brand-name">{order.brand}</span>
      </Fragment>
    );
  }, []);

  const RemoveBtn = useCallback(
    ({ order }) => {
      return (
        <Fragment>
          {!order.isFreeGift && !removingRow[order.rowSystemId] && (
            <Icon
              iconCode="delete"
              onClick={() => removeOrderRow(order.articleNumber)}
            />
          )}
        </Fragment>
      );
    },
    [removeOrderRow, removingRow]
  );

  return (
    <div
      className="row no-margin checkout-cart__mobile-row"
      key={orderRow.rowSystemId}
    >
      <div className="row checkout-cart__inner-row">
        <div className="small-2 checkout-cart__mobile-image-wrapper">
          <ProductImage order={orderRow} />
        </div>
        <div className="small-10">
          <div className="flex-container">
            <div className="small-10">
              <div className="checkout-cart__image-info">
                <ProductName order={orderRow} />
                <div className="checkout-cart__mobile-product-info">
                  {orderRow.erpArticleNumber && !b2c && (
                    <div>{orderRow.erpArticleNumber}</div>
                  )}
                  {orderRow.packSize > 0 && !b2c && (
                    <div>
                      {orderRow.packSize}
                      {translate('checkout.cart.pack')}
                    </div>
                  )}
                  {orderRow.size && (
                    <div>
                      {translate('checkout.cart.size')}: {orderRow.size}
                    </div>
                  )}
                  {orderRow.color && (
                    <div>
                      {translate('checkout.cart.color')}: {orderRow.color}
                    </div>
                  )}
                  <div className="checkout-cart__price-container">
                    <span>{translate('checkout.cart.pcsprice')}:</span>{' '}
                    <ProductPrice
                      order={orderRow}
                      hideDiscount={true}
                      cleanPrice={b2c}
                    />
                  </div>
                  <div className="checkout-cart__mobile-stock-container">
                    <span className="product-card__stock-status">
                      <span
                        className={`product-card__stock-status__icon product-card__stock-status__icon--${orderRow.deliveryStatus}`}
                      >
                        <Icon
                          iconCode="info"
                          iconClass={`product-card__stock-status__icon__i`}
                        />
                      </span>
                      {translate(
                        `checkout.cart.delivery.${orderRow.deliveryStatus}`
                      ).replace('{0}', orderRow.deliveryDate)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="small-2 columns flex-container align-right checkout-cart__mobile-remove">
              <RemoveBtn order={orderRow} />
            </div>
            {type == 'minicart' ? (
              <div className="checkout-cart__bottom-container checkout-cart__bottom-container--no-margin">
                <div className="checkout-cart__mobile-bottom-container small-12">
                  <div className="checkout-cart__quantity-container">
                    <BuyButtonPack
                      articleNumber={orderRow.articleNumber}
                      cssClass="btn btn--small btn--wide buy-button-pack__button buy-button product-card__buy-button"
                      label={translate('product.buy')}
                      packSize={orderRow.packSize > 0 ? orderRow.packSize : 1}
                      quantityFieldId={orderRow.rowSystemId}
                      type={'checkout'}
                      handleQuantityInput={handleQuantityInput}
                      orderQuantity={orderRow.quantity}
                    />
                  </div>
                  <div className="checkout-cart__total-price text--right">
                    <ProductTotalPrice
                      order={orderRow}
                      showPercentageDiscount={true}
                      cleanPrice={b2c}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="checkout-cart__bottom-container">
                <div className="checkout-cart__mobile-bottom-container">
                  <div className="checkout-cart__quantity-container">
                    <BuyButtonPack
                      articleNumber={orderRow.articleNumber}
                      cssClass="btn btn--small btn--wide buy-button-pack__button buy-button product-card__buy-button"
                      label={translate('product.buy')}
                      packSize={orderRow.packSize > 0 ? orderRow.packSize : 1}
                      quantityFieldId={orderRow.rowSystemId}
                      type={'checkout'}
                      handleQuantityInput={handleQuantityInput}
                      orderQuantity={orderRow.quantity}
                    />
                  </div>
                  <div className="checkout-cart__total-price text--right">
                    <ProductTotalPrice
                      order={orderRow}
                      showPercentageDiscount={true}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartProductCardMobile;
